import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BalanceQuery, config } from '@fgb/core';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { UserModule } from 'src/app/modules/user/user.module';

@Component({
  selector: 'fgb-mobile-header-bar',
  templateUrl: './mobile-header-bar.component.html',
  styleUrl: './mobile-header-bar.component.scss',
  standalone: true,
  imports: [CommonModule, RouterModule, DecimalPipe, FGBSharedModule, UserModule, NgbCollapseModule, DirectivesModule],
})
export class MobileHeaderBarComponent implements OnInit {
  @Input() title: string = '';
  @Input() link: string = '/';
  @Input() showPoints: boolean = true;

  loyaltyPointsCard$: Observable<number | undefined>;
  private balanceQuery = inject(BalanceQuery);

  ngOnInit(): void {
    this.loyaltyPointsCard$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
  }
}
